import { AngleColor } from "./Interface";


export const INITIAL_WIDTH = 1600;
export const INITIAL_HEIGHT = 900;
export const INITIAL_CIRCLE_RADIUS = 200;
export const GUIDE_TEXT_COORD = { x: 50, y: 20 };
export const CENTER_ANGLE_COLOR: AngleColor = {
  color: 0xFC99C4,
  textColor: 0xf94f6f
}
export const CIRCUM_ANGLE_COLOR: AngleColor = {
  color: 0x21D4FE,
  textColor: 0x0195b8
}
export const INFO_SLIDER_DIMS = {
  width: 405,
  height: 270,
}
export const LOGO_BOUNDS = {
  x: 1550,
  y: 100,
  width: 134,
  height: 134
}
export const BASE_PATH = "/static/images";

export const ROOT_ASSETS_LIST = [
  "/default.png",
  "/logo.png",
  "/logo-small.png",
  "/info-slider/mask.png",
  "/info-slider/arrow.png",
]

export const LOGO_PATH = "/logo.png";